import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../ui/Button';
import { useClerk } from '@clerk/clerk-react';

export const Header = () => {
  const { isAuthenticated } = useAuth();
  const { openSignIn, openSignUp, signOut } = useClerk();

  const handleLogout = async () => {
    await signOut({ redirectUrl: '/' });
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0A0E27]/80 backdrop-blur-md border-b border-[#2A2F4A]">
      <div className="container mx-auto px-4 md:px-6 py-3 md:py-4">
        <div className="flex items-center justify-between gap-2 md:gap-4">
          <Link to="/" className="text-xl md:text-2xl font-bold gradient-text whitespace-nowrap">
            Video Analyzer IA
          </Link>
          
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-300 hover:text-white transition">
              Home
            </Link>
            {isAuthenticated && (
              <>
                <Link to="/dashboard" className="text-gray-300 hover:text-white transition">
                  Dashboard
                </Link>
                <Link to="/dashboard/history" className="text-gray-300 hover:text-white transition">
                  Histórico
                </Link>
              </>
            )}
          </nav>
          
          <div className="flex items-center gap-2 md:gap-4">
            {isAuthenticated ? (
              <>
                <Link to="/dashboard">
                  <Button className="text-xs md:text-base px-3 md:px-6 py-2 md:py-3">Analisar</Button>
                </Link>
                <Button variant="outline" onClick={handleLogout} className="text-xs md:text-base px-3 md:px-6 py-2 md:py-3">
                  Sair
                </Button>
              </>
            ) : (
              <>
                <Button variant="outline" onClick={() => openSignIn()} className="text-xs md:text-base px-3 md:px-6 py-2 md:py-3">
                  Entrar
                </Button>
                <Button onClick={() => openSignUp()} className="text-xs md:text-base px-3 md:px-6 py-2 md:py-3">
                  Começar
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

